import { render, staticRenderFns } from "./sendgood.vue?vue&type=template&id=3ec626d1&scoped=true"
import script from "./sendgood.vue?vue&type=script&lang=js"
export * from "./sendgood.vue?vue&type=script&lang=js"
import style0 from "./sendgood.vue?vue&type=style&index=0&id=3ec626d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec626d1",
  null
  
)

export default component.exports